module.exports = __webpack_public_path__ + "static/media/done_circle.9323b66b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/done_circle.svg
// module id = 572
// module chunks = 33